import { Link } from "react-router-dom";

export default function Home() {
    const textStyle = {
        color: 'white',
        textAlign: 'center',
        width: '90%',
    }
    const linkStyle = {
        color: 'black',
        textAlign: 'center',        
        textDecoration: 'none',        
        backgroundColor: '#61dafb',
        padding: '10px 20px',
        borderRadius: '15px',
        

    }
    return (
        <div className="App">
           
            <main style={{justifyContent: 'center', gap: '20px', height: '100dvh'}}>
                <h2 style={textStyle}>Welcome to Your Inventory Management System</h2>
                <Link style={linkStyle} to="/dashboard" className="App-link">Go to Dashboard</Link>
            </main>

        </div>
    )
}